module.exports = __webpack_public_path__ + "static/media/con_spa_com_ind.3b984874.png";